module.exports = __webpack_public_path__ + "img/bria.052c2c2a.png";